export const INSURANCE_TYPE = (communityId: string) => `v1/insurance-types/community/${communityId}`;
export const INSURANCE_TYPE_WITHOUT_COMMUNITY = "v1/insurance-types";
